import * as React from 'react';
import { isEqual, parseISO } from 'date-fns';
import { Day, getDaysFromMonth } from '@features/price-graph';
const defaultMoney = { amount: 0, currency: null };
const Month = ({ initialDate, monthsPricesMap, prices, outDate, backDate, routeType, focusedDate, isMobileMode, onSelect }) => {
    var _a, _b;
    const isoInitialDate = initialDate.toISOString();
    const monthData = monthsPricesMap[isoInitialDate];
    const minPrice = (_a = monthData === null || monthData === void 0 ? void 0 : monthData.minPrice) !== null && _a !== void 0 ? _a : defaultMoney;
    const maxPrice = (_b = monthData === null || monthData === void 0 ? void 0 : monthData.maxPrice) !== null && _b !== void 0 ? _b : defaultMoney;
    return (React.createElement(React.Fragment, null, getDaysFromMonth(initialDate).map((date, index) => {
        var _a, _b;
        const dateISO = date.toISOString();
        const price = (_b = (prices.hasOwnProperty(dateISO) && ((_a = prices[dateISO]) === null || _a === void 0 ? void 0 : _a.price))) !== null && _b !== void 0 ? _b : {
            amount: 0,
            currency: maxPrice.currency
        };
        return (React.createElement(Day, { key: index, minPrice: minPrice, maxPrice: maxPrice, price: price, date: date, isOutDate: outDate && dateISO === outDate.toISOString(), isBackDate: backDate && dateISO === backDate.toISOString(), routeType: routeType, onSelect: onSelect, isFocused: focusedDate && isEqual(parseISO(focusedDate), date), isMobileMode: isMobileMode }));
    })));
};
export default Month;
